import { BaseDetail } from 'App/Component/Bases'
import fields from 'App/Screens/Job/Ranges/fields'

class PageAdd extends BaseDetail {
  constructor(props) {
    super(props)

    this.title = 'Range'
    this.urlData = 'module-job-range'
    this.fields = fields
    this.state = {
      isCheckingPermission: false,
      isAccessAllowed: true
    }
  }
}

export default PageAdd